import NotificationNew from './NotificationNew';

export default NotificationNew;
